import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { LandingPrincipal } from "views/landingPrincipal";
import { SignIn } from "views/signIn";
import { Dashboard } from "views/dashboard";
import { ForgotPassword } from "views/forgotPassword";
import { SignUp } from "views/signUp";
import { ResetPassword } from "views/resetPassword";
import { ProfileView } from "views/dashboard/components/ProfileView";
import { UpdateInvoiceView } from "views/dashboard/components/UpdateInvoiceView";
import { InvoiceDetailView } from "views/dashboard/components/InvoiceDetailView";

const theme = createTheme({
  palette: {
    primary: { main: '#0d47a1' },
    secondary: { main: '#f57c00' },
    background: { default: '#f5f5f5' }
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

const ProtectedRoute = ({ children }) => {
  const { isLogged } = useAuth();

  return isLogged
    ? children
    : <Navigate to="/sign-in" replace />;
};

const PublicRoute = ({ children }) => {
  const { isLogged } = useAuth();

  return !isLogged
    ? children
    : <Navigate to="/welcome" replace />;
};

const Router = () => {

  return (
    <ThemeProvider theme={theme}>

      <Routes>

        {/* PUBLICAS */}
        <Route path="/" element={<LandingPrincipal />} />

        <Route
          path="/sign-in"
          element={
            <PublicRoute>
              <SignIn />
            </PublicRoute>
          }
        />

        <Route
          path="/sign-up"
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />

        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />

        <Route
          path="/reset-password"
          element={<ResetPassword />}
        />

        {/* PRIVADAS */}

        <Route
          path="/welcome"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfileView />
            </ProtectedRoute>
          }
        />

        <Route
          path="/invoice-update/:invoiceId"
          element={
            <ProtectedRoute>
              <UpdateInvoiceView />
            </ProtectedRoute>
          }
        />

        {/* Detalle de factura a pantalla completa (se abre desde "Ver más") */}
        <Route
          path="/invoice-detail/:invoiceId"
          element={
            <ProtectedRoute>
              <InvoiceDetailView />
            </ProtectedRoute>
          }
        />

        {/* fallback */}
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />

      </Routes>

    </ThemeProvider>
  );
};


export default Router;